import { Injectable } from '@angular/core';
import { ObservationService } from './observation.service';
import { CategoryService } from './category.service';
import { HookSystemService } from '@kaiser-software/hook-system';
import { ChassisFormHandler, FormFactory } from '@kaiser-software/chassis-core';
import { MAIN_CATEGORY, MAIN_CATEGORY_FIELD } from '../forms/main-category-field';
import { SUB_CATEGORY, SUB_CATEGORY_FIELD } from '../forms/sub-category-field';

@Injectable()
export abstract class ObservationFormFactory {

    /**
     * @param observationService
     * @param categoryService
     * @param hookService
     * @param formFactory
     */
    constructor(
        protected observationService: ObservationService,
        protected categoryService: CategoryService,
        protected hookService: HookSystemService,
        protected formFactory: FormFactory) {
    }

    protected subCategoryData: {
        url?: string,
        id?: number,
    } = {};

    /**
     * @param data
     */
    public create(data: any): ChassisFormHandler {
        return this.createForm(data);
    }

    /**
     * @param data
     */
    protected createForm(data: any): ChassisFormHandler {
        this.registerFields();

        const options = {
            name: this.getFormName()
        };

        const form = this.formFactory.create(
            this.getEntityName(),
            data,
            options
        );

        form.formGroup.controls[MAIN_CATEGORY].valueChanges
            .subscribe((value) => {
                form.model[SUB_CATEGORY] = null;

                this.updateSubCategoryFieldData(form, value);
            });

        return form;
    }

    protected getEntityName(): string {
        return this.observationService.entityName;
    }

    protected abstract getFormName(): string;

    protected registerFields(): void {
        // Remove the previously registered filters.
        this.hookService.removeFilter('observation-form-register-fields');

        const event = 'form-build-before-build-' + this.getFormName();

        const callback = (form: any) => {
            this.registerMainCategoryField(form);
            this.registerSubCategoryField(form);

            return form;
        };

        // Register the filter.
        this.hookService.on(event, callback, 'observation-form-register-fields');
    }

    /**
     * @param form
     */
    protected registerMainCategoryField(form: ChassisFormHandler): void {
        // Remove the previously added main category field.
        if (form.hasElement(MAIN_CATEGORY)) {
            form.removeElement(MAIN_CATEGORY);
        }

        const section = <any>form.structure
            .groups[0]
            .sections[0];

        const data = {
            url: this.categoryService.getEndpointUrl(),
        };

        section.rows.unshift(MAIN_CATEGORY_FIELD(data));
    }

    /**
     * @param form
     */
    protected registerSubCategoryField(form: ChassisFormHandler): void {
        // Remove the previously added sub category field.
        if (form.hasElement(SUB_CATEGORY)) {
            form.removeElement(SUB_CATEGORY);
        }

        const section = <any>form.structure
            .groups[0]
            .sections[0];

        this.subCategoryData.url = this.categoryService.getEndpointUrl();

        section.rows.splice(1, 0, SUB_CATEGORY_FIELD(form, this.subCategoryData));
    }

    /**
     * @param form
     * @param value
     */
    protected updateSubCategoryFieldData(form: ChassisFormHandler, value: any): void {
        if (value) {
            this.subCategoryData.id = value.id;
        }
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/services/observation-form.factory.ts